module.exports = 
[
  {
    title: 'Sorting',
    description: 'An accumulation of sorting algorithms',
    link: '/resources/sorting'
  }
]